import type { FreelancerSearchFilters } from "@/domains/company/active-search/types";

// The filter dimensions that actually RESTRICT the pool (per the match contract).
// Excludes `job_offer_id` (the offer link, not a filter) and `experience_level`
// (accepted but a server-side no-op — it neither filters nor scores).
const RESTRICTING_FILTER_KEYS = [
  "search",
  "job_category",
  "skills",
  "work_preference",
  "price_per_day_min",
  "price_per_day_max",
  "weekly_hours",
  "available_from",
] as const satisfies readonly (keyof FreelancerSearchFilters)[];

/**
 * True when any restricting filter dimension is set. Drives the AC9 empty-state
 * discrimination: with filters active an empty result is `empty_filtered` ("no
 * saved talent matches the filters" + reset), otherwise `empty_pool` ("nothing
 * saved yet" + invite to save from Ricerca).
 *
 * Pure and DOM-free (node-testable).
 */
export const matchHasActiveFilters = (
  filters: FreelancerSearchFilters,
): boolean =>
  RESTRICTING_FILTER_KEYS.some((key) => {
    const value = filters[key];
    return value !== undefined && value !== null && value !== "";
  });
